module.exports = __webpack_public_path__ + "img/CMR-XXX_3b.0e07f629.png";